export const listClients = '/client-success/client-list';
export const createClient = '/client-success/create-client';
export const updateClient = '/client-success/update-client/:client_id';

export const userList = '/client-success/user-list';

export const featureToggles = '/client-success/feature-toggles';
export const capabilityDetail = '/client-success/feature-toggles/capability/:capability_id';
export const releaseToggleDetail = '/client-success/feature-toggles/release/:release_toggle_id';

export const CLIENTS_TAB_ROUTES = [listClients, createClient, updateClient];
export const USER_TAB_ROUTES = [userList];
export const FEATURE_FLAG_ROUTES = [featureToggles, capabilityDetail, releaseToggleDetail];
